import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { FloorPlan } from '../../../model/floorplan/floorplan';
import { Paging } from '../../../model/paging/paging';

@Injectable({
  providedIn: 'root'
})
export class FloorPlanService_Mock {
  GETPaginatedFloorPlans(projectId: string, paging: Paging): Observable<FloorPlan> | any {
    const allData = this.getMockFloorPlans().filter((item) => item.projectId === projectId);
    const start = (paging.pageIndex - 1) * paging.pageSize;
    const end = start + paging.pageSize;
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 16,
      data: {
        count: allData.length,
        items: allData.slice(start, end).map(({ svgContent, unitsPerMeter, ...item }) => item)
      }
    });
  }

  GETFloorPlanById(floorPlanId: string): Observable<FloorPlan> | any {
    const floorPlan = this.getMockFloorPlans().find((item) => item.floorPlanId === floorPlanId) ?? this.getMockFloorPlans()[0];
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 12,
      data: floorPlan
    });
  }

  POSTFloorPlan(body: FloorPlan) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 20,
      data: 'fp-new-floor-plan'
    });
  }

  PUTFloorPlanScale(floorPlanId: string, unitsPerMeter: number | null) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 11,
      data: true
    });
  }

  DELETEFloorPlan(floorPlanId: string) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 10,
      data: true
    });
  }

  private getMockFloorPlans(): FloorPlan[] {
    return [
      {
        floorPlanId: 'fp-9x8y7z',
        projectId: 'proj-1a2b3c',
        name: 'Piano Terra',
        svgContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 320"><rect width="500" height="320" fill="#f8fafc"/><rect x="40" y="40" width="420" height="240" rx="8" fill="#e2e8f0" stroke="#475569" stroke-width="4"/><rect x="90" y="90" width="110" height="70" fill="#cbd5e1"/><rect x="230" y="90" width="170" height="70" fill="#cbd5e1"/><rect x="90" y="180" width="310" height="60" fill="#cbd5e1"/></svg>',
        pixelsPerMeter: 0.02,
        unitsPerMeter: 0.02,
        createdAt: '2026-04-17T10:05:00Z'
      },
      {
        floorPlanId: 'fp-4r5t6y',
        projectId: 'proj-1a2b3c',
        name: 'Primo Piano',
        svgContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 360"><rect width="600" height="360" fill="#fff7ed"/><rect x="35" y="35" width="530" height="290" rx="10" fill="#fed7aa" stroke="#9a3412" stroke-width="4"/><path d="M180 35v290M360 35v290M35 180h530" stroke="#9a3412" stroke-width="4"/></svg>',
        pixelsPerMeter: 0.018,
        unitsPerMeter: 0.018,
        createdAt: '2026-04-18T08:20:00Z'
      },
      {
        floorPlanId: 'fp-7u8i9o',
        projectId: 'proj-z9y8x7',
        name: 'Magazzino',
        svgContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 320"><rect width="640" height="320" fill="#ecfeff"/><rect x="30" y="30" width="580" height="240" fill="#a5f3fc" stroke="#155e75" stroke-width="5"/><circle cx="160" cy="150" r="28" fill="#67e8f9"/><circle cx="320" cy="150" r="28" fill="#67e8f9"/><circle cx="480" cy="150" r="28" fill="#67e8f9"/></svg>',
        pixelsPerMeter: null,
        unitsPerMeter: null,
        createdAt: '2026-04-19T15:40:00Z'
      }
    ];
  }
}
